<template>
    <div>
        <div class="container">
            <div class="row my-5">
                <div class="col-12 col-md-6">
                    <div class="form-main-title">
                            <h1 class="heading">Welcome! Thanks for your interest in being one of our volunteers.</h1>
                        </div>
                        <p class="act-subtitle text-muted text-justify">A memorable event is a group effort. Therefore, we are looking to find and nurture a family and a community of people who are willing to work together in order to produce this ambitious 3 day event. There are many areas we need help and support including receiving guests, helping in art installations, guiding people, ticketing, information booth, good vibe generation, and more. Please send us your application and you will be registered for consideration in our selection process. This will take a bit of time. Please be patient and we’ll respond to you as we move through the process, certainly before mid-December.</p>
                </div>

                <div class="col-12 col-md-6">
                    <form class="form-entry" @submit.prevent="handleSubmit">
                            <div class="form-group">
                                <label for="name">Name</label>
                                <input type="text" v-model="enquiry.name" class="form-control" id="name" placeholder="Enter Your Name">
                            </div>
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="email" v-model="enquiry.email" class="form-control" id="email" placeholder="Enter Your Email">
                            </div>
                            <div class="form-group">
                                <label for="contact">Contact</label>
                                <input type="number" v-model="enquiry.phone" class="form-control" id="contact" placeholder="Enter your Contact Number">
                            </div>
                            <div class="form-group">
                                <label for="gender">Gender</label>
                                <select class="form-control" v-model="enquiry.gender" id="gender">
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="others">Others</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="address">Address</label>
                                <input type="text" v-model="enquiry.address" class="form-control" id="address" placeholder="Enter your Address">
                            </div>
                            <div class="d-flex justify-content-around mt-4 my-3">

                            <div class="form-check-inline">
                                <input type="checkbox" class="form-check-input" v-model="enquiry.joinAs" id="volunteer" value="volunteer">
                                <label class="form-check-label" for="exampleCheck1"> &nbsp; Volunteer Form</label>
                            </div>
                            <div class="form-check-inline">
                                <input type="checkbox" class="form-check-input" v-model="enquiry.joinAs" id="food & beverage" value="food & beverage">
                                <label class="form-check-label" for="exampleCheck1"> &nbsp; Food & Beverage Form</label>
                            </div>
                            <div class="form-check-inline">
                                <input type="checkbox" class="form-check-input" v-model="enquiry.joinAs" id="craft-vendor" value="craft-vendor">
                                <label class="form-check-label" for="exampleCheck1"> &nbsp; Craft Vendor Form</label>
                            </div>
                            <div class="form-check-inline">
                                <input type="checkbox" class="form-check-input" v-model="enquiry.joinAs" id="sponsor" value="sponsor">
                                <label class="form-check-label" for="exampleCheck1"> &nbsp; Be a Sponsor</label>
                            </div>
                            </div>
                            <div class="text-center">
                            <button v-if="loading" class="btn btn-primary mt-3 px-5" style="background:#B8B8B8 !important;" disabled>Submiting....</button>
                            <button v-else type="submit" class="btn btn-primary mt-3 px-5">SUBMIT</button>
                            </div>
                        </form> 
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios'
export default {
        data: () => ({
        enquiry: {
            name: '',
            gender: '',
            phone: '',
            email: '',
            address: '',
            subject: 'New Contact form enquiry-Metropolis',
            joinAs:[]
        },
        loading: false,
    }),
      methods: {
        handleSubmit() {
            // console.log(this.enquiry)
            // return;
            this.loading = true
            const url = "https://metropolisasia-new-default-rtdb.asia-southeast1.firebasedatabase.app/Enquiries.json"
            let data = JSON.stringify({ ...this.enquiry, timestamp: Date.now() })
            axios.post(url, data)
                .then(res => console.log(res))
                .finally(() => {                    
                    this.loading = false                    
                    this.fireAlert()                    
                })
        },
        fireAlert() {
            this.$fire({
                title: "Enquiry Sent Successfully",
                text: "We will be responding to your request shortly. Thanks!",
                type: "success",
                timer: 5000
            })
            .then(() => {                
                this.$refs.form.reset()                
            });            
        }
    }
}
</script>

<style scoped>
.btn{
    font-size: var(--default-font);
}
.act-subtitle{
    font-size: var(--default-font);
}
.form-entry{
    font-size: var(--default-font);
}
.form-entry .form-group{
    margin-bottom: 1.2rem;
}
.form-entry input{
    font-size: var(--default-font);
}
.form-entry select{
    font-size: var(--default-font);
}
.form-entry .form-check-label{
    font-size: var(--small-font);
}
.btn-primary{
    background: #fbd020 !important;
    border: 1px solid #fbd020;
    color: black;
    border-radius: none !important;
}
 @media (max-width: 700px){
    .act-subtitle{
        font-size: var(--default-font-mobile);
    }
    .form-entry{
    font-size: var(--default-font-mobile);
    }
    .form-entry .form-group{
        margin-bottom: 1.2rem;
    }
    .form-entry input{
        font-size: var(--default-font-mobile);
    }
    .form-entry select{
        font-size: var(--default-font-mobile);
    }
    .form-entry .form-check-label{
        font-size: .9rem;
    }
 }
</style>
